module.exports = __webpack_public_path__ + "img/setting.7f19cc85.png";